import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { ToastButton, ToastColors, ToastPosition, ToastIconSide } from '@/helpers/vfm/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastModal',
  props: {
    cssClass: { default: '' },
    message: { default: '' },
    duration: { default: 3000 },
    position: { default: 'bottom' },
    color: null,
    buttons: { default: () => [] }
  },
  emits: ['dismiss'],
  setup(__props: any, { emit: emits }) {

const props = __props as { cssClass: string, message: string, duration: number, position: ToastPosition, color?: ToastColors, buttons: ToastButton[] };




const startButtons = computed(() => props.buttons.filter(btn => btn.side === ToastIconSide.START));
const endButtons = computed(() => props.buttons.filter(btn => !btn.side || btn.side === ToastIconSide.END));

const style = computed(() => {
	if (props.position === 'middle') {
		return {};
	} else {
		return { [props.position]: '8px' };
	}
});

function onClick(btn: ToastButton) {
	if (btn.role === 'cancel') {
		emits('dismiss');
		return;
	}

	if (btn.handler) {
		btn.handler();
	}
}

onMounted(() => {
	if (props.duration > 0) {
		setTimeout(() => {
			emits('dismiss');
		}, props.duration);
	}
});

return { __sfc: true,props, emits, startButtons, endButtons, style, onClick }
}

})